import { useToken } from "./tokenContext";
import axios from "axios";
import https from "https-browserify";

const useApi = () => {
  const { token } = useToken();
  const apiUrl = process.env.REACT_APP_API_URL;
  const apiPort = process.env.REACT_APP_PORT_API;

  // Função auxiliar para criar instâncias de API com a porta correta
  const createApiInstance = (port) => {
    return axios.create({
      baseURL: `${apiUrl}/${port}`,
      httpsAgent: new https.Agent({ rejectUnauthorized: false }),
    });
  };

  const fetchData = async (url, port = apiPort) => {
    const api = createApiInstance(port);
    const response = await api.get(url, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response;
  };

  const deleteData = async (url, port = apiPort) => {
    const api = createApiInstance(port);
    const response = await api.delete(url, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response;
  };

  const updateData = async (url, data, port = apiPort) => {
    const api = createApiInstance(port);
    const response = await api.put(url, data, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    return response;
  };

  const postData = async (url, data, port = apiPort) => {
    const api = createApiInstance(port);
    const response = await api.post(url, data, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    return response;
  };

  const userLogin = async (url, data, port = apiPort) => {
    const api = createApiInstance(port);
    const response = await api.post(url, data, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response;
  };

  const postCSV = async (url, data, port = apiPort) => {
    const api = createApiInstance(port);
    const response = await api.post(url, data, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      responseType: "blob",
    });
    return response;
  };

  return { fetchData, deleteData, updateData, postData, postCSV, userLogin };
};

export default useApi;
